import { MoreDrawer } from '@src/pages/AutoInsights/AlertInsights/Insights';
import useDrawerState from '@src/pages/AutoInsights/Hooks/useDrawerState';
import { autoInsightsFeatureSelector } from '@store/common/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import Bulb from '@src/icons/insights/bulb.svg';
import { filterSelector } from '@store/aiAlerts/summary/selectors';
import { ALERT_INSIGHTS } from '@src/utils/sensor/track';
import FilterLabel from './FilterLabel';
import { InsightsBtn, IconWrap } from './styled';
import { Button } from 'antd';

function Insights() {
  const { visible, openDrawer, closeDrawer } = useDrawerState({ trackKey: ALERT_INSIGHTS });
  const autoInsightsEnabled = useSelector(autoInsightsFeatureSelector);
  const filter = useSelector(filterSelector);

  return autoInsightsEnabled ? (
    <div>
      {filter ? (
        <FilterLabel filter={filter} />
      ) : (
        <Button onClick={openDrawer} icon={<IconWrap><Bulb /></IconWrap>}>
          Insights
        </Button>
      )}
      <MoreDrawer visible={visible} closeMore={closeDrawer} />
    </div>
  ) : null;
}

export default Insights;
